import React from "react";
import { Button } from "primereact/button";
import * as styles from "./ImportButton.module.css";
import { useMobile } from "../../hooks/useMobile";

export const ImportButton = ({ onClick }) => {
  const { isMobile } = useMobile(600);
  return (
    <>
      {isMobile ? (
        <Button
          className={styles.iconButton}
          icon="pi pi-download"
          rounded
          text
          aria-label="Import"
          onClick={onClick}
        />
      ) : (
        <Button
          className={styles.button}
          label="Import"
          icon="pi pi-download"
          onClick={onClick}
        />
      )}
    </>
  );
};
